import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe } from 'lucide-react';
import { setCanonical, setMeta } from '../utils/seo';
import { SponsorBanner, AdSensePlaceholder } from './AdSlots';
import { PageSpeakable } from './SEOSchemas';

const REGIONS = { us: 'United States', uk: 'United Kingdom', eu: 'European Union', jp: 'Japan', kr: 'South Korea', au: 'Australia' };
const FLAGS = { us: 'US', uk: 'UK', eu: 'EU', jp: 'JP', kr: 'KR', au: 'AU' };

export default function ConversionsDirectory() {
  useEffect(() => {
    setCanonical('/conversions');
    setMeta('International Size Conversion Charts', 'Convert clothing sizes between US, UK, EU, Japan, Korea, and Australia. Free size conversion charts for all regions.');
  }, []);

  const regionKeys = Object.keys(REGIONS);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
      <PageSpeakable name="International Size Conversions" />
      <div className="mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-[#C5A028] mb-2">International Sizing</p>
        <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tighter text-[#1C1917] mb-4 speakable-intro">Size Conversion Charts</h1>
        <p className="text-[#78716C] max-w-xl">Convert clothing, shoe, and pants sizes between 6 regions worldwide. Click any combination below.</p>
      </div>

      {regionKeys.map(from => (
        <div key={from} className="mb-10">
          <h2 className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#1C1917] mb-4 flex items-center gap-2">
            <Globe className="w-5 h-5 text-[#C5A028]" /> From {REGIONS[from]}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {regionKeys.filter(to => to !== from).map(to => (
              <Link key={to} to={`/convert/${from}-to-${to}`} className="bg-white p-4 border border-[#E8E2D9] hover:border-[#C5A028] hover:shadow-md transition-all group" data-testid={`conv-${from}-${to}`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold bg-[#FAF8F4] px-2 py-1">{FLAGS[from]}</span>
                  <ArrowRight className="w-4 h-4 text-[#C5A028]" />
                  <span className="text-xs font-bold bg-[#FAF8F4] px-2 py-1">{FLAGS[to]}</span>
                </div>
                <p className="text-sm font-semibold text-[#1C1917] group-hover:text-[#C5A028] transition-colors">{REGIONS[to]}</p>
                <div className="mt-2 flex flex-wrap gap-1">
                  {['mens-tops', 'womens-tops', 'mens-shoes', 'womens-shoes', 'mens-pants'].map(d => (
                    <Link key={d} to={`/convert/${from}-to-${to}/${d}`} onClick={e => e.stopPropagation()} className="text-[10px] text-[#78716C] hover:text-[#C5A028] bg-[#FAFAFA] px-1.5 py-0.5 border border-[#E8E2D9]">
                      {d.replace('mens-', 'M ').replace('womens-', 'W ')}
                    </Link>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
      <SponsorBanner />
      <AdSensePlaceholder />
    </div>
  );
}
